import axios from "axios"

const getBankBranchList = async () => {
    return axios
        .get("BankDetails/GetAllBranch")
        .then((response) => response);
}

const bankBranchService = {
    getBankBranchList,
};

export default bankBranchService;